// extracted by mini-css-extract-plugin
export var box = "_13-2";
export var checkboxControl = "_13-0";
export var checkboxRow = "_13-a";
export var checked = "_13-3";
export var descriptionSpacer = "_13-c";
export var disabled = "_13-4";
export var icon = "_13-8";
export var input = "_13-1";
export var labelSpacer = "_13-b";
export var large = "_13-7";
export var medium = "_13-6";
export var small = "_13-5";
export var text = "_13-9";